import { AxiosInstance } from 'axios';
import { EventOrdersEnum, OrderParser, OrdersParser, Params } from './types';
import { parseEventOrder, parseEventOrders } from './utils';
import { handleErrorIntoService } from '@/tools/handleErrorIntoService';

export const getEventOrdersData = (api: AxiosInstance) => ({
  getEventOrders: async (
    params: Params,
    parseData: OrdersParser = parseEventOrders
  ): Promise<any> => {
    const { data } = await handleErrorIntoService(
      api.get<any>(EventOrdersEnum.GET_EVENT_ORDERS, {
        params,
      })
    );
    return { ...data, data: parseData(data.data) };
  },
});

export const getEventOrderData = (api: AxiosInstance) => ({
  getEventOrder: async (
    id: string,
    parseData: OrderParser = parseEventOrder
  ): Promise<any> => {
    const { data } = await handleErrorIntoService(
      api.get<any>(`${EventOrdersEnum.GET_EVENT_ORDER}/${id}`)
    );
    return { ...data, data: parseData(data.data) };
  },
});

export const postEventOrderCreateData = (api: AxiosInstance) => ({
  postEventOrderCreate: async (payload: any): Promise<any> => {
    return await api.post(EventOrdersEnum.POST_CREATE_EVENT_ORDER, {
      data: payload,
    });
  },
});

export const postCancelEventOrderData = (api: AxiosInstance) => ({
  postCancelEventOrder: async (id: string | number) => {
    const { data } = await handleErrorIntoService(
      api.post(`${EventOrdersEnum.POST_CANCEL_EVENT_ORDERS}/${id}`)
    );
    return { ...data };
  },
});

export const hideActivitiesOrder = (api: AxiosInstance) => ({
  hide: async (id: string | number) => {
    const { data } = await handleErrorIntoService(
      api.post(`${EventOrdersEnum.PATCH_HIDE_ORDER}/${id}`)
    );
    return { ...data };
  },
});

export const eventOrdersService = (api: AxiosInstance) => {
  if (!api) throw new Error('There is no HTTP client');
  return {
    ...getEventOrdersData(api),
    ...getEventOrderData(api),
    ...postCancelEventOrderData(api),
    ...postEventOrderCreateData(api),
    ...hideActivitiesOrder(api),
  };
};



// WEBPACK FOOTER //
// ./src/services/api/event-orders/eventOrdersService.ts